@if (collectionForm) {
  <div class="collection-dialog-container">

    <div class="hub-modal-header-text">
      @if (!existingCollection) {
        <h5 class="modal-title">Create a new Collection</h5>
      }
      @if (existingCollection) {
        <h5 class="modal-title">Edit Collection</h5>
      }
    </div>

    <div class="add-collection-dialog-content">

      <form [formGroup]="collectionForm">
        <div class="row mb-2">
          <div class="col-md-12">
            <span class="select-label text-info-800 d-block">Type<app-help-selector [selector]="1155">
            </app-help-selector></span>
            <div class="hub-select-container">
              <mat-form-field>
                <mat-select placeholder="Select a Collection Type" disableOptionCentering
                  formControlName="recordCollectionTypeId">
                  @for (ct of recordCollectionTypes; track ct) {
                    <mat-option
                      [value]="ct.recordCollectionTypeId">
                      {{ct.name}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="hub-validation-error-message">
              {{getValidationErrorMessages("recordCollectionTypeId")}}
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-12">
            <span class="select-label text-info-800 d-block">Name<app-help-selector [selector]="1156">
            </app-help-selector></span>
            <input type="text" class="form-control mb-2" formControlName="name" placeholder="Collection Name">
            <div class="hub-validation-error-message">
              {{getValidationErrorMessages("name")}}
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-12">
            <span class="select-label text-info-800 d-block">Description<app-help-selector [selector]="1157">
            </app-help-selector></span>
            <textarea rows="3" cols="3" class="form-control mb-2"
              placeholder='Enter a description for your Collection' formControlName="description">
            </textarea>
            <div class="hub-validation-error-message">
              {{getValidationErrorMessages("description")}}
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-12">
            <span class="select-label text-info-800 d-block">Privacy<app-help-selector [selector]="1158">
            </app-help-selector></span>
            <div>
              <mat-checkbox color="primary" id="isPrivate" formControlName="isPrivate"
              (change)="enableDisableShared($event)">Private Collection</mat-checkbox>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-12">
            <span class="select-label text-info-800 d-block">Sharing<app-help-selector [selector]="1212">
            </app-help-selector></span>
            <input type="text" matInput class="form-control mb-2" [ngClass]="{'is-private': isPrivate}"
              [formControl]="userTypeAhead"
              [placeholder]="isPrivate ? 'Cannot share a private collection' : 'Type and select a name to share'"
              [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayUser"
              (optionSelected)="user_clicked($event)">
              @for (user of filteredUsers$ | async; track user) {
                <mat-option [value]="user">
                  {{user.fullName}}
                </mat-option>
              }
            </mat-autocomplete>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-12">
            <span class="select-label text-info-800 d-block">Shared With</span>
            @if ((collectionForm.controls.recordCollectionUsers.value.length < 2 && !!existingCollection) || (collectionForm.controls.recordCollectionUsers.value.length === 0 && !existingCollection)) {
              <div class="dark-grey-text shared-with-padding "
                >
                This collection has
                not been shared yet
              </div>
            }
            <div class="shared-with-padding  tokenfield form-control hub-custom-scrollbar height-20vh">
              <div class="height-100">
                @for (rcu of collectionForm.controls.recordCollectionUsers.value; track rcu) {
                  <div class="token">
                    <span class="token-label">
                      {{rcu.user.firstName}} {{rcu.user.lastName}} {{rcu.user.userId ===
                      userDataService.getUserId() ? '(Self)' : ''}} {{rcu.user.isActive === false ?
                    '(Inactive)' : ''}}</span>
                    <span class="token-label">
                      {{rcu.user.businessUnit?.name}}
                    </span>
                    @if (collectionForm.controls.recordCollectionUsers.value.length > 1 || !existingCollection) {
                      <span
                      class="close" (click)="unselectUser(rcu.user)" aria-hidden="true">×</span>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="footer">
      <button (click)="close()" class="cancel-button">Cancel</button>
      <button type="button" class="hub-icon-button SaveButton" [ngClass]="{'saving': isSaving}"
        [disabled]="collectionForm.invalid || isSaving" (click)="save()">
        <b>
          <i class="icon-floppy-disk"></i>
          <i class="icon-spinner4"></i>
        </b>
        {{existingCollection ? 'Save' : 'Add'}}
      </button>
    </div>
  </div>
}
